/// <amd-module name="Repos/Views/FilesHub/Components/InvalidPath" />
import * as React from "react";
import { refToBranchName, specToRefName } from "Repos/Common/Util/Ref";
import { getVersionDisplayName } from "Repos/Common/Util/Version";
import { getGitRepository } from "Repos/Common/VCViewModelDataProviderService";
import * as Resources from "Repos/Views/FilesHub/Resources";
import { equals, format } from "VSS/Core/Util/String";
import { VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { ZeroData, ZeroDataActionType } from "VSSUI/ZeroData";
import { IFilesHubViewService, registerFilesHubTab } from "../FilesHubViewService";

export class InvalidPath extends VssComponent<{}> {
    public render() {
        const filesService = this.context.pageContext.getService<IFilesHubViewService>("IFilesHubViewService");

        const path = filesService.getSelectedItem().value.path;
        const version = filesService.getVersion();
        const repo = getGitRepository(this.context.pageContext)!;

        const message = format(Resources.InvalidFileMessageFormat, path, getVersionDisplayName(version));

        let actionText: string;
        let actionHref: string | undefined;
        let onActionClick: { (event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>): void } | undefined;

        if (equals(repo.defaultBranch, specToRefName(version))) {
            actionText = Resources.GoToRepositoryRoot;
            actionHref = filesService.getItemUrl("/");
            onActionClick = (event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => {
                filesService.setSelectedPath("/");
                event.preventDefault();
            };
        } else {
            actionText = Resources.GoToDefaultBranch;
            actionHref = filesService.getItemUrl(path, { version: "GB" + refToBranchName(repo.defaultBranch) });
        }

        return (
            <ZeroData
                className="flex-grow"
                imagePath={getAssetLocation(this.context.pageContext, "ms.vss-code-web/files-hub-content-new/Content/invalid-path.svg")}
                imageAltText={message}
                primaryText={Resources.InvalidFileTitle}
                secondaryText={message}
                actionType={ZeroDataActionType.ctaButton}
                actionText={actionText}
                actionHref={actionHref}
                onActionClick={onActionClick}
            />
        );
    }
}

registerFilesHubTab({
    getTab: (pageContext, item, editMode) => {
        if (item.isInvalid && !item.isNewItem) {
            return {
                id: "contents",
                name: Resources.Contents,
                order: 10,
                render: () => {
                    return <InvalidPath />;
                }
            };
        }
    }
});
